export const ACTION_NOTIFY = 1
export const ACTION_DEDUCT_POINT = 2
export const ACTION_FORBID_ORDER = 3
export const ACTION_BAN = 4

export const ACTION_OPTIONS = [
  {label: '仅警告通知', value: ACTION_NOTIFY},
  {label: '扣除零豆或赏金', value: ACTION_DEDUCT_POINT},
  {label: '禁止做单', value: ACTION_FORBID_ORDER},
  {label: '永久封号', value: ACTION_BAN},
]

export const ACTION_MAP = ACTION_OPTIONS.reduce((map, item) => {
  map[item.value] = item.label
  return map
}, {})

export const STATUS_ENABLED = 1
export const STATUS_DISABLED = 0

export const BAN_REASON_OPTIONS = [
  {label: '多账号', value: 1},
  {label: '非本人使用', value: 2},
  {label: '虚假提交', value: 3},
  {label: '账号异常', value: 4},
  {label: '恶意抢单', value: 5},
  {label: '态度恶劣', value: 6},
  {label: '本人申请', value: 7},
  {label: '其他', value: 99},
]

export const DETAIL_STATUS_PENDING = 0
export const DETAIL_STATUS_SENT = 1
export const DETAIL_STATUS_READ = 2
export const DETAIL_STATUS_FAILED = 3
export const DETAIL_STATUS_RECALLED = 4
export const DETAIL_STATUS_RECALLING = 5
export const DETAIL_STATUS_RECALL_FAILED = 6

/** 名单搜索筛选项（不含撤回中/撤回失败） */
export const DETAIL_STATUS_SEARCH_OPTIONS = [
  {label: '待发送', value: DETAIL_STATUS_PENDING},
  {label: '已发送', value: DETAIL_STATUS_SENT},
  {label: '已读', value: DETAIL_STATUS_READ},
  {label: '发送失败', value: DETAIL_STATUS_FAILED},
  {label: '已撤回', value: DETAIL_STATUS_RECALLED},
]

export const DETAIL_STATUS_OPTIONS = [
  ...DETAIL_STATUS_SEARCH_OPTIONS,
  {label: '撤回中', value: DETAIL_STATUS_RECALLING},
  {label: '撤回失败', value: DETAIL_STATUS_RECALL_FAILED},
]

export const DETAIL_STATUS_MAP = DETAIL_STATUS_OPTIONS.reduce((map, item) => {
  map[item.value] = item.label
  return map
}, {})

export const DETAIL_STATUS_TAG_TYPE = {
  [DETAIL_STATUS_PENDING]: 'warning',
  [DETAIL_STATUS_SENT]: '',
  [DETAIL_STATUS_READ]: 'success',
  [DETAIL_STATUS_FAILED]: 'danger',
  [DETAIL_STATUS_RECALLED]: 'info',
  [DETAIL_STATUS_RECALLING]: 'warning',
  [DETAIL_STATUS_RECALL_FAILED]: 'danger',
}

export function formatPunishParams (row) {
  const action = Number(row.action)
  if (action === ACTION_DEDUCT_POINT) {
    const parts = []
    if (Number(row.punish_point) > 0) parts.push(`扣 ${row.punish_point} 零豆`)
    if (Number(row.punish_salary) > 0) parts.push(`扣 ${row.punish_salary} 元赏金`)
    return parts.length ? parts.join(' + ') : '—'
  }
  if (action === ACTION_FORBID_ORDER) {
    return row.punish_day ? `禁止做单 ${row.punish_day} 天` : '禁止做单'
  }
  if (action === ACTION_BAN) {
    const reason = BAN_REASON_OPTIONS.find(i => i.value === Number(row.ban_reason))
    return reason ? `永久封号（${reason.label}）` : '永久封号'
  }
  return '仅警告通知'
}

/**
 * 撤回确认弹窗：用户展示文案
 * @param {Object} row
 * @param {Object} [options]
 * @param {boolean} [options.compact=false] 批量预览用紧凑格式（不带「用户ID」四字）
 */
export function formatRecallUserLabel (row, options) {
  if (!row) return '—'
  const name = (row.user_name || '').trim()
  const uid = row.userid
  const compact = !!(options && options.compact)
  if (name) {
    return compact ? `「${name}」（${uid}）` : `「${name}」（用户ID ${uid}）`
  }
  return compact ? `${uid}` : `用户ID ${uid}`
}

/** 撤回确认弹窗：手机号脱敏 */
export function maskCellphone (phone) {
  const raw = String(phone || '').trim()
  if (!raw) return '—'
  if (raw.indexOf('*') >= 0) return raw
  if (/^1\d{10}$/.test(raw)) {
    return `${raw.slice(0, 3)}****${raw.slice(-4)}`
  }
  return raw
}

/** 撤回确认弹窗：处理方式（紧凑文案，对齐原型） */
export function formatRecallActionDetail (row) {
  if (!row) return '—'
  const action = Number(row.action)
  if (action === ACTION_DEDUCT_POINT) {
    const parts = []
    if (Number(row.punish_point) > 0) parts.push(`扣${row.punish_point}零豆`)
    if (Number(row.punish_salary) > 0) {
      parts.push(`扣¥${Number(row.punish_salary).toFixed(2)}赏金`)
    }
    return parts.length ? parts.join(' ') : '仅警告通知'
  }
  if (action === ACTION_FORBID_ORDER) {
    return row.punish_day ? `禁止做单${row.punish_day}天` : '禁止做单'
  }
  if (action === ACTION_BAN) {
    return '永久封号'
  }
  return '仅警告通知'
}

/** 撤回确认弹窗：是否展示关联项目（扣除零豆/赏金且赏金>0，对齐原型） */
export function shouldShowRecallProject (row) {
  return !!(row && Number(row.action) === ACTION_DEDUCT_POINT && Number(row.punish_salary) > 0)
}

/** 撤回确认弹窗：关联项目文案 */
export function formatRecallProject (row) {
  if (!row || !Number(row.projectid)) return '—'
  const name = (row.project_name || '').trim()
  if (name) return `${name} / ${row.projectid}`
  return String(row.projectid)
}

/** 撤回确认弹窗：金额展示 */
export function formatRecallMoney (amount) {
  const num = Number(amount)
  if (isNaN(num)) return '0.00'
  return num.toFixed(2)
}

/** 撤回确认弹窗：发送时间（优先展示时分秒） */
export function formatRecallSentTime (sentAt) {
  const raw = String(sentAt || '').trim()
  if (!raw) return '—'
  const parts = raw.split(' ')
  if (parts.length >= 2 && /^\d{2}:\d{2}:\d{2}$/.test(parts[1])) {
    return parts[1]
  }
  return raw
}



// WEBPACK FOOTER //
// ./src/views/violation-alert/violation-alert.constants.js